import { GetAccountMeetingsPerWorkspaceSummaryQuery } from '../../../../../src/interface/queries/org-metrics/meetings/get-account-meetings-per-workspace-summary.query';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountMeetingsPerWorkspaceSummaryAggregateRootMapper } from '../../../../../src/infrastructure/mappers/org-metrics/meetings/account-meetings-per-workspace-summary.aggregate-root.mapper';
import { GetAccountMeetingsPerWorkspaceSummaryRequestDto } from '../../../../../src/interface/dtos/org-metrics/meetings/get-account-meetings-per-workspace-summary.request.dto';
import { GetAccountMeetingsPerWorkspaceSummaryResponseDto } from '../../../../../src/interface/dtos/org-metrics/meetings/get-account-meetings-per-workspace-summary.response.dto';


export class GetAccountMeetingsPerWorkspaceSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountMeetingsPerWorkspaceSummaryQuery,
    protected readonly mapper: AccountMeetingsPerWorkspaceSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountMeetingsPerWorkspaceSummaryRequestDto
  ): Promise<GetAccountMeetingsPerWorkspaceSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountMeetingsPerWorkspaceSummaryController.get encountered an error ${error}`
      );
    }
  }
}
